import { useState } from "react";
import { versionTabs } from "@/mocks/home";

export default function VersionTabs() {
  const [active, setActive] = useState(versionTabs[0].id);
  const current = versionTabs.find((tab) => tab.id === active) ?? versionTabs[0];

  return (
    <section id="versions" className="bg-background-50 border-t border-background-200">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-3xl">
          <span className="text-xs md:text-sm font-medium tracking-wide text-accent-700">
            版本差异
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-3xl font-semibold text-foreground-950 leading-snug">
            完整版、未删减、无删减版与高清完整版怎么区分
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">
            这四个说法经常一起出现，却各自站在不同角度描述同一部影片。切换标签查看每种说法的关注点与常见误区。
          </p>
        </div>

        <div className="mt-8 inline-flex flex-wrap gap-1 p-1 rounded-full bg-background-200 border border-background-300">
          {versionTabs.map((tab) => (
            <button
              key={tab.id}
              type="button"
              onClick={() => setActive(tab.id)}
              aria-pressed={active === tab.id}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                active === tab.id
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-700 hover:text-primary-700"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10 items-start">
          <div className="lg:col-span-7 rounded-lg bg-background-100 border border-background-200 p-5 md:p-8">
            <div className="text-xs font-medium text-accent-700">{current.subtitle}</div>
            <h3 className="mt-2 font-heading text-xl md:text-2xl font-semibold text-foreground-950">
              {current.label}
            </h3>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">
              {current.summary}
            </p>

            <ul className="mt-6 space-y-3">
              {current.features.map((feature) => (
                <li key={feature} className="flex items-start gap-3">
                  <span className="w-6 h-6 shrink-0 rounded-full bg-primary-100 text-primary-700 flex items-center justify-center mt-0.5">
                    <i className="ri-check-line text-sm"></i>
                  </span>
                  <span className="text-sm leading-relaxed text-foreground-800">{feature}</span>
                </li>
              ))}
            </ul>

            <div className="mt-7 flex items-start gap-3 rounded-lg bg-accent-50 border border-accent-200 p-4">
              <span className="w-7 h-7 shrink-0 rounded-full bg-accent-500 text-background-50 flex items-center justify-center">
                <i className="ri-error-warning-line text-sm"></i>
              </span>
              <p className="text-xs md:text-sm leading-relaxed text-accent-900">{current.note}</p>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="w-full aspect-[4/3] rounded-lg overflow-hidden border border-background-200 bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=vintage%20film%20reel%20and%20clapperboard%20on%20a%20wooden%20table%20with%20warm%20golden%20hour%20light%20through%20a%20window%2C%20cozy%20moody%20atmosphere%2C%20editorial%20still%20life%20photography%2C%20soft%20shadows%2C%20rich%20terracotta%20and%20amber%20tones%2C%20shallow%20depth%20of%20field%2C%20high%20detail&width=900&height=700&seq=sister-friend-version-01&orientation=landscape"
                alt="暖色调的电影胶片与场记板场景，象征不同版本的对比"
                className="w-full h-full object-cover object-top"
              />
            </div>

            <div className="mt-5 rounded-lg bg-secondary-50 border border-secondary-200 p-5">
              <h4 className="flex items-center gap-2 font-heading text-base font-semibold text-secondary-900">
                <i className="ri-lightbulb-line"></i>
                判断版本的小技巧
              </h4>
              <p className="mt-2 text-sm leading-relaxed text-secondary-900/80">
                把“内容长度”和“画面质量”当成两条独立的线：先确认时长与段落是否完整，再确认分辨率与字幕是否合格，
                不要用一个标签同时下结论。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}